import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import cn from 'classnames';
import { createStore } from 'justorm/react';
import { Icon } from '../Icon/Icon.js';
import { generateUID } from '../../tools/uid.js';
import S from './Checkbox.styl.js';

class Checkbox extends Component {
    id;
    store;
    static defaultProps = {
        size: 'm',
        variant: 'default',
        label: '',
        checked: false,
    };
    constructor(props) {
        super(props);
        this.id = props.id || generateUID();
        this.store = createStore(this, { isActive: false, isFocused: false });
    }
    onMouseDown = () => {
        this.store.isActive = true;
    };
    onMouseUp = () => {
        this.store.isActive = false;
    };
    onFocus = (e) => {
        const { onFocus } = this.props;
        this.store.isFocused = true;
        onFocus?.(e);
    };
    onBlur = (e) => {
        const { onBlur } = this.props;
        this.store.isFocused = false;
        onBlur?.(e);
    };
    render() {
        const { className, label, size, variant, error, ...props } = this.props;
        const { checked, disabled } = props;
        const { isActive, isFocused } = this.store;
        const classes = cn(S.root, S[`size-${size}`], S[`variant-${variant}`], checked && S.checked, disabled && S.disabled, error && S.hasError, isActive && S.isActive, isFocused && S.isFocused, className);
        return (jsxs("label", { className: classes, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, children: [jsxs("div", { className: S.controlWrapper, children: [jsx("input", { className: S.control, ...props, onFocus: this.onFocus, onBlur: this.onBlur, id: this.id, type: "checkbox", tabIndex: 0 }), jsx(Icon, { type: "check", className: S.checkmark, size: size })] }), label] }));
    }
}

export { Checkbox };
